(function () {
  if (window.__wnfBedSwapInit) return;
  window.__wnfBedSwapInit = true;

  // wnf-bed-swap-script-intent-gate-2026-06-21: never auto-rotate decorative open-bed images before shopper intent; late swaps can become mobile LCP.
  function onIntent(callback) {
    if (window.__wnfBedSwapIntent) {
      callback();
      return;
    }

    function markIntent() {
      window.__wnfBedSwapIntent = true;
      window.removeEventListener('pointerdown', markIntent);
      window.removeEventListener('touchstart', markIntent);
      window.removeEventListener('wheel', markIntent);
      window.removeEventListener('keydown', markIntent);
      callback();
    }

    window.addEventListener('pointerdown', markIntent, { once: true, passive: true });
    window.addEventListener('touchstart', markIntent, { once: true, passive: true });
    window.addEventListener('wheel', markIntent, { once: true, passive: true });
    window.addEventListener('keydown', markIntent, { once: true });
  }

  function init() {
    var cards = document.querySelectorAll('.is-sleeper-grid');
    if (!cards.length) return;

    var isHoverCapable = window.matchMedia && window.matchMedia('(hover: hover)').matches;

    var ROTATE_INTERVAL_MS = 7000;
    var EXTENDED_DURATION_MS = 3000;
    var STAGGER_MAX_MS = 2500;

    cards.forEach(function (card) {
      if (!card.querySelector('.wnf-bed-extended-img')) return;

      var timer = null;
      var rotating = false;

      function tick() {
        if (!rotating) return;
        card.classList.add('is-bed-extended');
        setTimeout(function () {
          if (!rotating) return;
          card.classList.remove('is-bed-extended');
        }, EXTENDED_DURATION_MS);
      }

      function start() {
        if (timer || rotating) return;
        rotating = true;
        var stagger = Math.random() * STAGGER_MAX_MS;
        setTimeout(function () {
          if (!rotating) return;
          tick();
          timer = setInterval(tick, ROTATE_INTERVAL_MS);
        }, stagger);
      }

      function stop() {
        rotating = false;
        if (timer) { clearInterval(timer); timer = null; }
        card.classList.remove('is-bed-extended');
      }

      if (!isHoverCapable) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting && e.intersectionRatio >= 0.5) {
                start();
              } else {
                stop();
              }
            });
          }, { threshold: [0, 0.5, 1] });
          io.observe(card);
        } else {
          // Older browsers without IO: rotate continuously on the visible cards.
          start();
        }
      }
      // Desktop hover handled by CSS :hover (no JS needed)
    });
  }

  function scheduleInit() {
    // wnf-bed-swap-idle-init-2026-06-20: decorative mobile card rotation can wait until after first paint.
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(init, { timeout: 2000 });
    } else {
      window.setTimeout(init, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { onIntent(scheduleInit); });
  } else {
    onIntent(scheduleInit);
  }
})();
